import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import EventButton from '../../../modules/analytics/components/EventButton/EventButton';
var Indicator = function Indicator(_ref) {
  var index = _ref.index,
    currentIndex = _ref.currentIndex,
    changeCurrentIndex = _ref.changeCurrentIndex,
    event = _ref.event;
  return /*#__PURE__*/React.createElement(EventButton, {
    "aria-label": "Carousel image number ".concat(index),
    event: _objectSpread(_objectSpread({}, event), {}, {
      value: index
    }),
    className: "ic-carousel-indicator",
    style: {
      padding: 0,
      background: 'none'
    },
    onClick: function onClick() {
      return changeCurrentIndex(index);
    },
    size: "large",
    icon: index === currentIndex ? 'circle' : 'circle outline'
  });
};
Indicator.defaultProps = {
  event: {
    category: 'Carousel',
    action: 'Click',
    label: 'Image Collection'
  }
};
export default Indicator;